export default function solutionsCard(root: HTMLElement): () => void {
  const cards = [...root.querySelectorAll<HTMLElement>('[data-solutions-card]')];
  const seeMoreWrap = root.querySelector<HTMLElement>('[data-solutions-see-more-wrap]');
  const seeMoreBtn = root.querySelector<HTMLButtonElement>('[data-solutions-see-more]');
  const mobileViewport = window.matchMedia('(max-width: 1023px)');
  const initialVisibleCards = 5;
  let isExpanded = false;

  if (cards.length === 0) {
    root.hidden = true;
    return () => {};
  }

  const updateVisibility = (): void => {
    const shouldCollapse =
      mobileViewport.matches && !isExpanded && cards.length > initialVisibleCards;

    cards.forEach((card, index) => {
      const hideCard = shouldCollapse && index >= initialVisibleCards;

      card.classList.toggle('hidden', hideCard);
      card.toggleAttribute('hidden', hideCard);
    });

    if (!seeMoreWrap) {
      return;
    }

    const shouldShowButton =
      mobileViewport.matches && !isExpanded && cards.length > initialVisibleCards;

    seeMoreWrap.classList.toggle('hidden', !shouldShowButton);
    seeMoreWrap.classList.toggle('flex', shouldShowButton);
    seeMoreWrap.toggleAttribute('hidden', !shouldShowButton);
  };

  if (seeMoreBtn) {
    seeMoreBtn.addEventListener('click', event => {
      event.preventDefault();
      isExpanded = true;
      updateVisibility();
    });
  }

  const controller = new AbortController();

  mobileViewport.addEventListener('change', updateVisibility, { signal: controller.signal });
  updateVisibility();

  return (): void => {
    controller.abort();
  };
}
